import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ParticipantModel, PhoneCountryCodeResponseModel } from 'src/api-providers/models/participant.model';
import { SessionModel } from 'src/api-providers/models/session.model';
import { ParticipantsViewModel } from 'src/api-providers/view-models/participants.view.model';
import { ModalParticipantFormComponent } from '../modal-participant-form/modal-participant-form.component';
import { ModalDeleteComponent } from '../modal-delete/modal-delete.component';
import { StandardResponseModel } from 'src/api-providers/models/event.model';
import { EventsViewModel } from 'src/api-providers/view-models/events.view.model';

@Component({
  selector: 'app-participant-card',
  templateUrl: './participant-card.component.html',
  styleUrls: ['./participant-card.component.scss'],
  providers: [ParticipantsViewModel]
})
export class ParticipantCardComponent {
  @Input() notList: boolean;
  @Input() participantModel: ParticipantModel;
  @Input() participantEventDetailId: string = '';
  @Input() eventSessions: SessionModel[] = [];
  @Input() participantAttendance: boolean = false;
  @Input() participantSessionsAttendance: Number[] = [];
  @Input() admitCardIssued: boolean = false;

  @Output() shareAdmitCardEvent = new EventEmitter<any>();;

  sender_account:any
  // admitCardIssued: boolean = false;
  emailSenderResponseModel = new BehaviorSubject<StandardResponseModel>(new StandardResponseModel())

  phoneCountryCodeResponseModel = new BehaviorSubject<PhoneCountryCodeResponseModel>(new PhoneCountryCodeResponseModel());
  static StaticCall: any;

  constructor(
    private participantVM: ParticipantsViewModel,
    private eventsVM: EventsViewModel,
  ){
    // this.eventsVM.getEventSenderList();
  } 

  ngOnInit(){
    this.participantVM.parentParticipantCardComponent = this;
    this.participantVM.subscribeToPhoneCodeModel(this.phoneCountryCodeResponseModel);
    this.eventsVM.subscribeToEmailSenderResponseModel(this.emailSenderResponseModel);
  
  }

  // cardReceived(data:any){
  //   this.admitCardIssued = data.results[0].issued;
  // }

  changeParticipantAttendance(e: any){
    this.participantAttendance = e.target.checked;
    this.participantVM.updateAttendance(this.participantEventDetailId, this.participantAttendance)
  }

  changeSessionAttendance(e: any, sessionId: number){
    var check = e.target.checked;
    if(check){
      if(!(this.participantSessionsAttendance.includes(sessionId)))
      this.participantSessionsAttendance.push(sessionId)
    } else {
      this.participantSessionsAttendance = this.participantSessionsAttendance.filter(el => el != sessionId);
    }
    this.participantVM.updateSessions(this.participantEventDetailId, this.participantSessionsAttendance);
    
  }
  
  getPhoneValue(id: number){
    // var el = this.phoneCountryCodeResponseModel.value.results.find(el => el.id == id); 
    // return el?.code
  }

  downloadParticipantQR(participantModel: ParticipantModel){
    var filename = participantModel.first_name + ' ' + participantModel.last_name
    this.participantVM.downloadParticipantQR(this.participantEventDetailId, filename);
  }

  downloadAdmitCard(participantModel: ParticipantModel){
    var filename =  participantModel.first_name + '_' + participantModel.last_name +'_admit'
    this.participantVM.downloadEventAdmitCard(this.participantEventDetailId,filename);
  }

  

  editParticipant(participantModel: ParticipantModel){
    var participant = participantModel;
    if(participant){
      ModalParticipantFormComponent.StaticCall.updateParticipantFields(participant);
    } else {
      ModalParticipantFormComponent.StaticCall.participantModel = undefined;
      ModalParticipantFormComponent.StaticCall.initFormFields();
    }
  }

  deleteParticipant(participantModel: ParticipantModel){
    ModalDeleteComponent.StaticCall.removeParticipantEventDetail = true;
    ModalDeleteComponent.StaticCall.deleteObject = { 
      name: (participantModel.first_name + ' ' + participantModel.last_name), 
      id: this.participantEventDetailId
    };
  }

  shareAdmitCard(participantModel: ParticipantModel){
    this.shareAdmitCardEvent.emit(true);
  }
}
